<div class="events-list-container">
  <div class="title-area">
    <h2>Todos os eventos</h2>
  </div>

  <div class="summary-area">
    <app-paginator-report [meta]="eventsPage?.meta" />
  </div>

  <div class="events-area" [class.events-area--loading]="isLoading && !!eventsPage">
    @if (!eventsPage) {
      <p-skeleton height="250px" />
      <p-skeleton height="250px" />
      <p-skeleton height="250px" />
      <p-skeleton height="250px" />
      <p-skeleton height="250px" />
      <p-skeleton height="250px" />
    } @else {
      @for (event of eventsPage.data; track event.id) {
        <app-event-card class="event-card" [event]="event" />
      } @empty {
        <div class="grid-span">
          <p>Nenhum evento encontrado. Tente ajustar os filtros.</p>
        </div>
      }
    }
  </div>
  <div class="actions-area">
    @if (eventsPage && eventsPage.meta.total_count > 0) {
      <app-loading [hasOverlay]="false" [hidden]="!isLoading" />

      <p-paginator
        [hidden]="isLoading"
        [first]="first"
        [rows]="rows"
        [totalRecords]="eventsPage.meta.total_count"
        (onPageChange)="handlePageChange($event)"
        [showCurrentPageReport]="false" />
    }
  </div>
</div>
